<template>
  <div class="container-fluid" v-if="poster && poster.content">
    <div class="row bg-primary pt-2 pb-2 d-print-none">
      <div class="col text-start font-weight-bold" v-if="!isMobile()">{{ poster.presentation_code }}
        <span v-html="poster.title"></span>
      </div>
      <div class="col text-start smaller" v-else>{{ poster.presentation_code }} <span
          v-html="poster.title"></span></div>
    </div>
    <div class="row bg-primary font-weight-bold mb-2 d-print-none">
      <div class="col d-flex ">
        <router-link :to="getBackUrl()" class="btn text-bg-primary btn-sm mr-auto my-auto">
          <icon :icon="['fal', 'square-list']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_overview }}</div>
        </router-link>
        <router-link class="btn  btn-sm" :to="'/viewer/' + poster.abstract_id"
                     title="Switch to abstract">
          <icon :icon="['fal', 'file-pdf']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_back_presentation }}</div>
        </router-link>
        <router-link class="btn  btn-sm" :to="'/viewer/video/' + poster.abstract_id"
                     title="Switch to abstract" v-if="poster.content.video">
          <icon :icon="['fal', 'film']" class="fa-3x"/>
          <div class="my-auto">{{ _.card_video }}</div>
        </router-link>
        <button class="btn btn-sm" v-print v-if="setting.print === true">
          <icon :icon="['fal', 'print']" class="fa-3x"/>
          <div class="my-auto">{{ _.poster_nav_print }}</div>
        </button>
      </div>
    </div>
    <div class="row mt-3 text-primary d-print-inline">
      <div class="col col-lg-8 offset-lg-2">
        <h4>{{ poster.presentation_code }} <span v-html="poster.title"></span></h4>
        <div v-html="poster.template"></div>
      </div>
    </div>
    <div class="row mt-3 text-primary mb-2 d-print-inline">
      <div class="col text-center smaller">
        {{ _.abstract_footer }}
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row mt-3">
      <div class="col">
        {{ poster }}
        <Loader></Loader>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import Loader from "../components/Loader.vue";

export default {
  name: "ViewerAbstract",
  components: {Loader},
  computed: {
    ...mapState(['fullscreen', 'poster', 'setting']),
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      getPosterById: 'getPosterById',
    }),
    getBackUrl() {
      return '/view/' + this.$route.params.id;
    },
    toggleFullscreen() {
      this.$store.state.fullscreen = !this.$store.state.fullscreen;
    },
    async getPdf() {
      this.$store.commit('setPoster', {});
      this.getPosterById(this.$route.params.id).then((response) => {
        this.$store.commit('setPoster', response.data);
      }).catch((error) => {
      })
    },
  },
  mounted() {
    this.$store.state.fullscreen = true;
  },
  async created() {
    await this.getPdf();
    this.$store.dispatch('TRACK_ACTION', {
      'value': this.$route.params.id,
      'action': 'viewer/abstract',
      'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
    });
  }
}
</script>

<style scoped>
@media print {
  .col {
    page-break-inside: auto !important;
  }
}
</style>
